module.exports = __webpack_public_path__ + "img/googleheader.1041abb6.png";